import { useQuery } from 'react-query'
import { useApi } from '../components/ApiContext'

export const useMe = () => {
  const api = useApi()
  return useQuery('api.getMe', api.getMe)
}
